/* eslint no-undef: 'off' */
/* eslint no-console: 'off' */
import $ from 'jquery';


const bookingCart = () => {
    const target = ".js-BookingCart";
    const targetSingleProduct = ".wb-SingleProduct .js-BookingCart__Add";
    const $target = $(target);
    const $targetSingleProduct = $(targetSingleProduct);

    const init = () => {
        if ($target.length || $targetSingleProduct.length) {
            exec();
        }
    };

    const el = {
        cartPopup: '.js-BookingCart__Popup',
        cartPopupOpen: '.js-BookingCart__Popup_BtnOpen',
        cartPopupClose: '.js-BookingCart__Popup_BtnClose',
        cartItem: '.js-BookingCart__Item',
        cartAdd: '.js-BookingCart__Add',
        cartRemove: '.js-BookingCart__Remove',
        cartTable: '.js-BookingCart__Table tbody',
        cartEmptyMsg: '.js-BookingCart__EmptyMsg',
        theCart: '.js-BookingCart__Addons__Card',
        productLists: '.js-ProductLists',
    };


    const exec = () => {
        $(function() {
            // Open Popup
            $(el.cartPopupOpen).on('click', function() {
                console.log('openn')
                $(this).parent().parent().parent().find('.js-BookingCart__Popup').addClass('open')
            });

            // Close Popup
            $(el.cartPopupClose).on('click', function() {
                $(el.cartPopup).removeClass('open');
            });

            $(".js-Product__OG").on('click', function() {
                setTimeout(function () {
                    localStorage.clear();
                    window.location.href = "/aanbod";
                }, 500)
                $('.js-LoadingScreen').addClass('active');
                
            })

            let installationFeesByProduct = JSON.parse(localStorage.getItem('installationFeesByProduct')) || {};

            // Add item
            $(el.cartAdd).on('click', function() {

                
                const reservationDatesData = JSON.parse(localStorage.getItem("reservationDates"));
                
                const start = (reservationDatesData.startDate);
                const end = (reservationDatesData.endDate);
                const startDate = new Date(reservationDatesData.startDate);
                const endDate = new Date(reservationDatesData.endDate);
                 // Calculate the time difference in milliseconds
                const timeDifference = endDate - startDate;
                const dayDifference = timeDifference / (1000 * 60 * 60 * 24) + 1;
                $('.js-AddonsProduct__DiffDays').val(dayDifference);
                const diffDayVal = reformatPriceToInt($('.js-AddonsProduct__DiffDays').val());
                const dataProductId = $(this).data('product-id');
                
                const data = {
                    action: 'get_available_products',
                    nonce: $('#nonce').val(), 
                    product_id: dataProductId,
                    start_date: start,
                    end_date: end,
                };

                const installationFeeVal = parseInt($(this).data('instalation')) || 0;
                installationFeesByProduct[dataProductId] = installationFeeVal;
                localStorage.setItem('installationFeesByProduct', JSON.stringify(installationFeesByProduct));

                
                $.ajax({
                    url: themeObj.ajaxUrl, 
                    method: 'POST',
                    data: data,
                    success: function(response) {
                        if (response.success) {
                            const $tableHtml = $(response.data.table_html);
                            const $listHtml = $(response.data.list_html);


                            const $specificRow = $tableHtml.filter(`[data-product-id="${dataProductId}"]`);
                            const $specificList = $listHtml.filter(`[data-product-id="${dataProductId}"]`);  
                            
                            
                            
                            if ($specificRow.length) {
                                $(el.cartTable).append($specificRow);
                                $(el.productLists).append($specificList);
                                $(el.cartPopup).removeClass('open');
                                $(el.cartEmptyMsg).removeClass('open');
                                saveToLocalStorage(dataProductId, $specificRow[0].outerHTML, $specificList[0].outerHTML);
                                $(`.js-BookingCart__Card[data-product-id="${dataProductId}"]`).addClass('hide');

                                // Update step1Data in localStorage without replacing existing data
                                const step1Data = JSON.parse(localStorage.getItem('step1Data')) || {};
                                const productIds = step1Data.productIds || [];

                                // Add the new product ID if it's not already in the array
                                if (!productIds.includes(dataProductId)) {
                                    productIds.push(dataProductId);
                                }

                                // Update step1Data with the updated productIds array
                                step1Data.productIds = productIds;
                                localStorage.setItem('step1Data', JSON.stringify(step1Data));
                            }

                            

                            calculatePrices()

                        } else {
                            console.error('Failed to add item:', response.data);
                        }
                    },
                    error: function(error) {
                        console.error('Error adding item:', error);
                    }
                });

                function calculatePrices() {
                    const borgSettingVal = reformatPriceToInt($('#deposit_setting').val());
                    const diffDayValTest = reformatPriceToInt($('.js-AddonsProduct__DiffDays').val());
                
                    const addonsPricesData = JSON.parse(localStorage.getItem("addonsPrices")) || {};
                    const pricesArray = Object.values(addonsPricesData);
                    
                    // Retrieve stored installation fees from localStorage
                    const storedInstallationFees = JSON.parse(localStorage.getItem('installationFeesByProduct')) || {};
                
                    const calculatedPrices = pricesArray.map((price, index) => {
                        const productId = Object.keys(addonsPricesData)[index];
                        const installationFeeVal = storedInstallationFees[productId] || 0;


                        // let priceEach = price / diffDayValTest;
                        // let priceDealVal = priceEach + ((diffDayValTest - 1) * (priceEach / 2)) + borgSettingVal;
                        let priceDealVal = price;
                        // console.log(priceEach)
                
                        // Add the specific installation fee from the stored data
                        priceDealVal += installationFeeVal;
                
                        return { priceDealVal, installationFeeVal };
                    });
                
                    const totalSum = calculatedPrices.reduce((acc, item) => acc + item.priceDealVal, 0);
                    const totalInstallationFeeTotal = calculatedPrices.reduce((acc, item) => acc + item.installationFeeVal, 0);
                    console.log(pricesArray);
                    
                    const totalSumHuurjs = pricesArray.reduce((acc, price) => acc + price, 0);
                    const totalBorg = borgSettingVal * pricesArray.length;
                
                    localStorage.setItem('totalPrice', totalSum);
                    localStorage.setItem('totalInstallationFee', totalInstallationFeeTotal);
                    localStorage.setItem('totalBorg', totalBorg);
                    localStorage.setItem('totalHuurjs', totalSumHuurjs);
                
                    $('.js-ReservationPrice.Huurprijs').text(`€${totalSumHuurjs.toFixed(2).replace('.', ',')}`);
                    $('#total_price.totalPrice').text(`€${totalSum.toFixed(2).replace('.', ',')}`);
                    $('#installation_fee').text(`€${totalInstallationFeeTotal.toFixed(2).replace('.', ',')}`);
                    $('.ReserverenBody__mobile #installation_fee').text(`€${totalInstallationFeeTotal.toFixed(2).replace('.', ',')}`).toString()
                }

                

                const addonItems = {};
                const addonsItemId = $(this).data('product-id');
                console.log(`diff: `+diffDayVal);
                
                const priceEachItem = $(this).data('product-price') + (($(this).data('product-price')/2) * (diffDayVal - 1));
                


                if (addonsItemId) {
                    addonItems[addonsItemId] = priceEachItem;
                }

                // Update and save addonItems to localStorage
                const existingAddonPrices = JSON.parse(localStorage.getItem('addonsPrices')) || {};
                console.log(addonItems);
                
                const updatedAddonPrices = { ...existingAddonPrices, ...addonItems };
                localStorage.setItem('addonsPrices', JSON.stringify(updatedAddonPrices));
                

                // Get the product type from the element's data attribute
                const productTypeItem = {};
                const productTypeId = $(this).parent().parent().parent().data('product-id');
                const productTypeData =  $(this).data('product-type');


                if (productTypeId) {
                    productTypeItem[productTypeId] = productTypeData;
                }

                // Update and save addonItems to localStorage
                const existingProductType = JSON.parse(localStorage.getItem('productType')) || {};
                const updatedProductType = { ...existingProductType, ...productTypeItem };
                localStorage.setItem('productType', JSON.stringify(updatedProductType));

            });


            const reformatPriceToInt = (price = "") => {
                if (typeof price !== "string") return;
            
                return +price.split(",")[0].replace("€", "").trim();
            };

             // Function to save items to localStorage
            function saveToLocalStorage(productId, tableHtml, listHtml) {
                let addonsItem = JSON.parse(localStorage.getItem('addonsItem')) || {};
                addonsItem[productId] = {
                    tableHtml: tableHtml,
                    listHtml: listHtml
                };
                localStorage.setItem('addonsItem', JSON.stringify(addonsItem));
            }
            
            // Function to remove an item from localStorage
            
            function removeFromLocalStorage(productId) {
                // Get and update addonsItem data
                let addonsItem = JSON.parse(localStorage.getItem('addonsItem')) || {};
                delete addonsItem[productId];
                localStorage.setItem('addonsItem', JSON.stringify(addonsItem));
                $(`.js-BookingCart__Card[data-product-id="${productId}"]`).removeClass('hide');
            
                // Get and update addonsPrices data
                let addonsPricesData = JSON.parse(localStorage.getItem('addonsPrices')) || {};
                delete addonsPricesData[productId];
                localStorage.setItem('addonsPrices', JSON.stringify(addonsPricesData));
                
                // Get and update productType data
                let productTypeData = JSON.parse(localStorage.getItem('productType')) || {};
                delete productTypeData[productId];
                localStorage.setItem('productType', JSON.stringify(productTypeData));
            
                // Get and update installationFeesByProduct data
                let installationFeesByProductData = JSON.parse(localStorage.getItem('installationFeesByProduct')) || {};
                delete installationFeesByProductData[productId];
                localStorage.setItem('installationFeesByProduct', JSON.stringify(installationFeesByProductData));
            
                // Calculate the total installation fee directly from the updated installationFeesByProduct data
                const totalInstallationFeeTotal = Object.values(installationFeesByProductData).reduce((acc, fee) => acc + parseInt(fee), 0);
                localStorage.setItem('totalInstallationFee', totalInstallationFeeTotal);  // Store in localStorage
            
                // Calculate prices based on updated localStorage data
                const borgSettingVal = reformatPriceToInt($('#deposit_setting').val());
                const pricesArray = Object.keys(addonsPricesData).map(productId => {
                    const price = parseInt(addonsPricesData[productId]) || 0;
                    const installationFee = parseInt(installationFeesByProductData[productId]) || 0;
                    return price + installationFee;
                });
            
                // Calculate the total sum with installation fees included
                const totalSum = pricesArray.reduce((acc, price) => acc + price, 0);
                const totalSumHuurjs = Object.values(addonsPricesData).reduce((acc, price) => acc + parseInt(price), 0);
                const totalBorg = borgSettingVal * pricesArray.length;
                
                // Modify step1Data in localStorage to remove the deleted additional product ID
                const step1Data = JSON.parse(localStorage.getItem('step1Data')) || {};
                const productIds = step1Data.productIds || [];
                // console.log(`productIds id before deleted: ${productIds}`);
                
                // Remove the selected product ID
                if (productIds.includes(productId)) {
                    productIds.splice(productIds.indexOf(productId), 1);
                }
                // console.log(`productIds id: ${productIds}`);
                

                // Update step1Data with the updated productIds array
                step1Data.productIds = productIds;
                localStorage.setItem('step1Data', JSON.stringify(step1Data));


                // Set additional totals in localStorage
                localStorage.setItem('totalPrice', totalSum);
                localStorage.setItem('totalBorg', totalBorg);
                localStorage.setItem('totalHuurjs', totalSumHuurjs);
            
                // Update the DOM with the latest totals
                $('.js-ReservationPrice.Huurprijs').text(`€${totalSumHuurjs.toFixed(2).replace('.', ',')}`);
                $('#total_price.totalPrice').text(`€${totalSum.toFixed(2).replace('.', ',')}`);
                $('#deposit_fee').text(`€${totalBorg.toFixed(2).replace('.', ',')}`);
                $('#installation_fee').text(`€${totalInstallationFeeTotal.toFixed(2).replace('.', ',')}`);
                $('.ReserverenBody__mobile #installation_fee').text(`€${totalInstallationFeeTotal.toFixed(2).replace('.', ',')}`).toString()
            }
            

            

            // Function to load cart items from localStorage on page load
            function loadCartFromLocalStorage() {
                const addonsItem = JSON.parse(localStorage.getItem('addonsItem')) || {};
                for (const [productId, { tableHtml, listHtml }] of Object.entries(addonsItem)) {
                    $(el.cartTable).append(tableHtml);
                    $(el.productLists).append(listHtml);
                    $(`.js-BookingCart__Card[data-product-id="${productId}"]`).addClass('hide');
                }
            }

            // Load the cart items when the page loads
            $(document).ready(function() {
                loadCartFromLocalStorage();
                
                const borgSettingVal = reformatPriceToInt($('#deposit_setting').val());
                const diffDayValTest = reformatPriceToInt($('.js-AddonsProduct__DiffDays').val());
                

                
                const priceOrder = JSON.parse(localStorage.getItem("priceOrders"));
                let priceEach = priceOrder.price / diffDayValTest;

                
                const installationFeeData = JSON.parse(localStorage.getItem("totalInstallationFee")) || parseFloat($("#installation_fee").text().replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
                const totalBorgData = JSON.parse(localStorage.getItem("totalBorg")) || 0;
                const totalHuurjsData = JSON.parse(localStorage.getItem("totalHuurjs")) || priceOrder.price;
                
                const discPriceTotal = priceEach + ((diffDayValTest - 1) * (priceEach / 2)) + installationFeeData +  borgSettingVal;
                const totalPriceData = JSON.parse(localStorage.getItem("totalPrice")) || discPriceTotal;

                const productTypeData = JSON.parse(localStorage.getItem('productType') || '{}'); 

                const hasFigure = Object.values(productTypeData).some(value => value === "figure");
                const allFiguresOrEmpty = Object.values(productTypeData).every(value => value === "figure");

                // console.log()

                if (hasFigure) {
                    // $(".js-DeliveryOptions").removeClass('active');
                    $(".js-GreetingText").addClass('active');
                    if (Object.keys(productTypeData).length <= 1) {
                        $(".js-DeliveryOptions").addClass('active');
                    }
                
                    // if (allFiguresOrEmpty) {
                    //     $(".js-DeliveryOptions").addClass('active');
                    // } else {
                    //     $(".js-DeliveryOptions").addClass('active');
                    //     // $(".js-DeliveryOptions").removeClass('active');
                    // }
                }

                const totalPrice = +totalHuurjsData + +installationFeeData

                // console.log(totalPrice)

                $('.js-ReservationPrice.Huurprijs').text(`€${totalHuurjsData.toFixed(2).replace('.', ',')}`);
                $('.js-totalPriceData').text(`€${totalPrice.toFixed(2).replace('.', ',')}`);
                // $('.js-totalPriceData').text(`€${totalPrice.toFixed(2).replace('.', ',')}`);
                $('#deposit_fee').text('€0');
                $('#installation_fee').text(`€${installationFeeData.toFixed(2).replace('.', ',')}`);
                $('.ReserverenBody__mobile #installation_fee').text(`€${installationFeeData.toFixed(2).replace('.', ',')}`).toString()

                $(el.cartTable).on('click', '.js-BookingCart__Remove', function() {
                    const productId = $(this).closest('.js-BookingCart__Item').data('product-id');
                    $(`.js-BookingCart__Card[data-product-id="${productId}"]`).removeClass('hide');
                    $(`.js-ProductLists .ReservationInformation__ItemText[data-product-id="${productId}"]`).remove();

                    $(this).closest('.js-BookingCart__Item').remove();

                    removeFromLocalStorage(productId);
                });

                
            });
        });
    };

    init();
};

try {
    bookingCart();
} catch (error) {
    console.error(error);
}
